var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",staticStyle:{"height":"100%"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":this.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }